import { Button } from 'primereact/button'
import { InputText } from 'primereact/inputtext'
import React, { useCallback, useMemo, useState } from 'react'
import { useLocalState } from '../../../../shared/UseLocalState'
import { HorseApi, Person, PersonApi } from '../../../../api'
import { authState } from '../../../../state/Auth.state'
import { Loading } from '../../../loading/Loading'
import { DataTable } from 'primereact/datatable'
import { registrationState } from '../Registration.state'
import { Column } from 'primereact/column'
import { appState } from '../../../../state/App.state'
import {
  Starter,
  StarterExmsDto,
  StarterResponse,
} from '../../../../api'
import { ShowDto } from '../../../../types/ShowDto'
import { HorseByRegId } from '../../../../shared/HorseByRegId'
import { ExamByStarter, PersonByRegId } from '../../../../shared/RiderByRegId'
import { actualShowState } from '../../../../state/ActualShow.state'
import { horsesState } from '../../../../state/Horses.state'

export const UpdateScreen = () => {
  /* STATE */
  const user = useLocalState<Person | null>(authState.user$, authState.user$.value)
  const selectedUser = useLocalState<Person | null>(registrationState.selectedRider$, registrationState.selectedRider$.value)
  const selectedStarter = useLocalState<Starter | null>(registrationState.selectedStarter$, registrationState.selectedStarter$.value)
  const [regId, setRegId] = useState<string>('')
  const [loading, setLoading] = useState(false)
  const additionalUsers = useLocalState<Person[]>(registrationState.additionalRiders$, registrationState.additionalRiders$.value)

  const actualShow = useLocalState<ShowDto | undefined>(actualShowState.actualShow$, actualShowState.actualShow$.value)
  const starters = useLocalState<Starter[]>(actualShowState.actualShowStarters$, actualShowState.actualShowStarters$.value)

  /* DERIVED STATE */
  const userOptions: Person[] = useMemo(() => (user ? [user, ...additionalUsers] : additionalUsers), [user, additionalUsers])

  /* LOGIC */
  const getRiderByRegId = useCallback(() => {
    if ([user, ...additionalUsers]?.some((horse) => horse?.registerId === regId))
      return appState.addToast('Reiter bereits in Tabelle!', 'warning')
    setLoading(true)
    new PersonApi(authState.apicfg())
      .apiPersonRegisterRegisterIdGet({
        registerId: regId
      })
      .then((p) => {
        appState.addToast('Reiter gefunden: ' + p?.firstName + ' ' + p?.lastName, 'info')
        registrationState.additionalRiders$.next([...registrationState.additionalRiders$.value, p])
        registrationState.selectedRider$.next(p)
      })
      .catch(() => {
        appState.addToast('Reiter mit RegId ' + regId + ' nicht gefunden', 'error')
      })
      .finally(() => setLoading(false))
  }, [regId])

  /* TEMPLATE */
  return (
    <>
      <Loading loading={loading} />

      {starters?.length < 1 && <h3>Sie haben noch keine Startnummer gebucht!</h3>}
      {starters?.length > 0 && (
        <>
          <h3>
            Ihre schon gebuchten Startnummern. Zum nachnennen oder stornieren bitte eine Starnummer auswählen. <br />
            {}
          </h3>

          <DataTable
            value={starters}
            showSelectAll={false}
            showHeaders={false}
            //value={userOptions}
            selectionMode={'single'}
            selection={selectedStarter}
            onSelectionChange={async (e) => {
              try {
                const starter = (e?.value as Starter) ?? null
                if (starter) {
                  setLoading(true)
                  const horseId = starter?.horseRegisterId
                  const riderId = starter?.riderRegisterId
                  // fetch horse
                  const horse = await new HorseApi(authState.apicfg()).apiHorseRegisterIdGet({ registerId: `${horseId ?? -1}` })
                  // only if horse not already in list
                  if (!horsesState.horses$.value?.some((h) => h?.registerId === horseId)) {
                    registrationState.additionalHorses$.next([
                      ...(registrationState.additionalHorses$.value?.filter((h) => h?.registerId !== horseId) ?? []),
                      horse
                    ])
                  }
                  // fetch rider
                  const rider = await new PersonApi(authState.apicfg()).apiPersonRegisterRegisterIdGet({ registerId: `${riderId ?? -1}` })
                  //if (authState?.user$?.value?.registerId !== riderId) {
                  registrationState.additionalRiders$.next([
                    ...(registrationState.additionalRiders$.value?.filter((r) => r?.registerId !== riderId) ?? []),
                    rider
                  ])
                  //}
                  // get exams
                  const exams = actualShowState.actualShowExams$.value?.filter((e) =>
                    (starter as any)?.bookedExams?.some((e2: any) => e?.id === e2?.examId && !e2?.cancelDate)
                  )
                  // set state
                  registrationState.selectedHorse$.next(horse)
                  registrationState.selectedRider$.next(rider)
                  registrationState.selectedExams$.next(exams)
                  console.log(starter)
                  registrationState.gweGateExam$.next(
                    (starter as any)?.bookedExams?.reduce((no: number, e2: StarterExmsDto) => (e2?.gweGateExam ? e2?.examId : no), -1)
                  )
                } else {
                  registrationState.selectedHorse$.next(null)
                  registrationState.selectedRider$.next(null)
                  registrationState.selectedExams$.next([])
                  registrationState.selectedServices$.next([])
                  registrationState.gweGateExam$.next(-1)
                }
                registrationState.selectedStarter$.next(starter)
              } catch (e) {
                console.error(e)
              } finally {
                setLoading(false)
              }
            }}
            emptyMessage='Keine Buchungen!'
          >
            <Column selectionMode='single' bodyStyle={{ width: '3rem' }} />
            <Column header='StartNr.' body={(starter: Starter) => starter?.startNo} />
            <Column header='Pferd' body={(starter: Starter) => <HorseByRegId regId={starter?.horseRegisterId} />} />
            <Column header='Reiter' body={(starter: Starter) => <PersonByRegId regId={starter?.riderRegisterId} />} />

            <Column
              header='Prüfungen'
              body={(starter: StarterResponse) =>
                starter?.bookedExams ? <ExamByStarter bookedExams={starter?.bookedExams} /> : <span>Keine Prüfungen</span>
              }
            />
          </DataTable>
        </>
      )}




    </>
  )
}
